import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Container } from '../../../base/Container'
import AppToaster from '../../../commonLib/AppToaster'
import { loadingMiniContext } from '../../../commonLib/lodingMiniContext'
import { TimelineHistory } from '../../Global/TimelineHistory'
import *as productProcessingReceivingCrud from '../../../_crud/productProcessingReceivingCrud'
import { ProcessingReceivingItemView } from './ProcessingReceivingItemView'
import { loadingContext } from '../../../commonLib/_lodingContext'

export function ProcessingReceivingDashBoard() {
    const [isLoadingMini, setIsLoadingMini] = useContext(loadingMiniContext)
    const [isLoading, setIsLoading] = useContext(loadingContext)
    const [processingReceiving, setProcessingReceiving] = useState()
    const { id } = useParams()

    function doRefresh() {
        getData()
    }

    useEffect(() => {
        getData()
    }, []);


    function getData() {
        setIsLoading(true);
        setIsLoadingMini(true);
        productProcessingReceivingCrud.GetById(id)
            .then(res => {
                if (res.data.data) {
                    if (res.data.result.succeeded) {
                        let hdata = res.data.data
                        setProcessingReceiving(hdata);
                        setIsLoading(false)
                        setIsLoadingMini(false)
                    }
                    else {
                        setIsLoading(false)
                        setIsLoadingMini(false)
                        setProcessingReceiving([]);
                    }
                }
                else {
                    setIsLoading(false)
                    setIsLoadingMini(false)
                    setProcessingReceiving([]);
                    AppToaster("Server Error /Invalid Try.", 'error')
                }
            })
            .catch(error => {
                    setIsLoading(false)
                    setIsLoadingMini(false);
                AppToaster(error, 'error')
            })
    }

    return (
        <Container title="Processing Receiving Dashboard" doRefresh={doRefresh} isBack="true" >

            <div className="row">
                <div className="col-lg-8">
                <ProcessingReceivingItemView processingReceiving={processingReceiving} />
                </div>
                <div className="col-lg-4">
                    <TimelineHistory id={id} type={5} pageSize={10} text="Processing Receiving Timeline" />
                </div>
            </div>
        </Container >
    )
}

